<template>
  <div class="loginContainer">
    <div class="weixinCodeContainer" v-if="showWeixinCode">
      <div id="weixin_qr_code_container" class="qrCodeWrapper" />
      <a-button class="closeButton" @click="closeWxCode">
        <icon-font type="close" />
      </a-button>
    </div>
    <div v-else>
      <div>
        <div class="titleBar" v-if="loginWithPassword">
          <span>{{ $t("user.login.welcome1") }}</span>
          <span
            class="mainColor textGap"
            :style="isEn ? { marginLeft: '0' } : {}"
          >
            {{ $t("user.login.welcome2") }}
          </span>
        </div>
        <span v-else class="titleBar mainColor"
          >{{ $t("user.login.code") }}
        </span>
      </div>
      <div class="toRegister">
        <span class="toRegisterBtn" @click="goToRegister">
          {{ $t("user.login.new") }}
        </span>
      </div>
      <div class="formContainer">
        <a-button
          v-if="false"
          class="radiusBtnFull weChatBtn"
          type="primary"
          block
          @click="toggleShowWeixinCode"
        >
          <icon-font type="weixin" class="iconWechat" />
          {{ $t("user.login.wx") }}
        </a-button>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <phone-and-email-form-item
          :placeholder="
            !loginWithPassword ? $t('user.login.name.placeholder') : undefined
          "
        />
        <password-form-item v-if="loginWithPassword" />
        <captcha-form-item v-else :phoneNumber="currentPhoneNumber" />
        <a-button
          class="radiusBtnGhost submitBtn"
          type="primary"
          block
          html-type="submit"
          :loading="isSubmitting"
        >
          {{ $t("user.login") }}
        </a-button>
      </a-form>
      <div class="toCodeLogin">
        <span
          class="toCodeLoginBtn"
          @click="loginWithPassword = !loginWithPassword"
        >
          {{
            loginWithPassword ? $t("user.login.code") : $t("user.login.account")
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/** 密码登录表单 */
import IconFont from "@/components/IconFont";
import { pickPhoneNumberOrEmail } from "@/utils/validator";
import PhoneAndEmailFormItem from "./PhoneAndEmailFormItem";
import PasswordFormItem from "./PasswordFormItem";
import CaptchaFormItem from "./CaptchaFormItem";
import { FormType } from "@/models/user";
import UserApi from "@/api/user";
import { JwtUtil } from "@/utils/jwt";

export default {
  name: "PasswordLoginForm",
  components: {
    IconFont,
    PhoneAndEmailFormItem,
    PasswordFormItem,
    CaptchaFormItem,
  },
  props: {
    goTo: {
      type: Function,
      default: () => {},
    },
    setWechatUnionId: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      form: null,
      showWeixinCode: false,
      loginWithPassword: true,
      toRegister: false,
      isSubmitting: false,
      currentPhoneNumber: undefined,
    };
  },
  created() {
    this.form = this.$form.createForm(this, {
      name: "login",
      onValuesChange: (_, values) => {
        if (values.phoneNumber !== undefined) {
          this.currentPhoneNumber = values.phoneNumber;
        }
      },
    });
  },
  computed: {
    isEn: function() {
      return this.$i18n.locale === "en-US";
    },
  },
  watch: {
    showWeixinCode: function(val) {
      if (val) {
        UserApi.fetchWeixinConfig().then((res) => {
          const { app_id } = res.data;
          const redirectUri = `${window.location.origin}/redirect/index.html`;
          const encodedRedirectUri = encodeURIComponent(redirectUri);

          // eslint-disable-next-line no-undef
          new WxLogin({
            self_redirect: true,
            id: "weixin_qr_code_container",
            appid: app_id,
            scope: "snsapi_login",
            redirect_uri: encodedRedirectUri,
            style: "black",
            /**
             * href的值为样式的base64编码, 具体样式在 ./wechat.css里面
             * 也可设置为一个url路径功能，指向对应的css文件，但是打包之后不晓得具体的文件放到哪了（除非打包是对这个特殊处理，或者放到pulic文件夹里面）
             */
            href:
              "data:text/css;base64," +
              "LmltcG93ZXJCb3ggewogIHRleHQtYWxpZ246IGNlbnRlcjsKfQouaW1wb3dlckJveCAudGl0bGUgewogIG1hcmdpbi1ib3R0b206IDMycHg7CiAgY29sb3I6ICMyNjI2MjY7CiAgZm9udC1zaXplOiAyNHB4OwogIGxpbmUtaGVpZ2h0OiAyOHB4Owp9Ci5pbXBvd2VyQm94IC5xcmNvZGUgewogIGJveC1zaXppbmc6IGJvcmRlci1ib3g7CiAgd2lkdGg6IDI0OHB4OwogIGhlaWdodDogMjQ4cHg7CiAgbWFyZ2luOiAwOwogIGJvcmRlcjogMXB4IHNvbGlkICNkZGQ7Cn0KLmltcG93ZXJCb3ggLmluZm8gewogIHdpZHRoOiAxMDAlOwogIGNvbG9yOiAjMzkzOTM5OwogIGZvbnQtc2l6ZTogMTJweDsKICBsaW5lLWhlaWdodDogMjBweDsKfQouaW1wb3dlckJveCAuaW5mbyAuc3RhdHVzIHsKICBwYWRkaW5nOiAxMHB4IDA7Cn0KLmltcG93ZXJCb3ggLmluZm8gcCB7CiAgbWFyZ2luLWJvdHRvbTogMDsKfQo=",
          });
          this.initWeixinQrCode();
        });
      }
    },
  },
  methods: {
    closeWxCode() {
      this.showWeixinCode = false;
    },
    goToRegister() {
      this.goTo(FormType.REGISTE);
    },
    toggleShowWeixinCode() {
      this.showWeixinCode = true;
    },
    loginSuccess(response) {
      JwtUtil.setJwtToken(
        (response.data.legal_entities[0].token || "").replace("Bearer ", "")
      );
      window.location.href = "/";
    },
    fetchUnionId(weixinCode) {
      UserApi.fetchWeixinUnionId(weixinCode).then((res) => {
        if (res.data.code) {
          this.$message.warn(res.message);
          return;
        }
        // 获取到unionId后尝试使用此登录
        // 成功则跳转到项目中心，报错则跳转至微信绑定
        UserApi.weixinLogin(res.data.union_id)
          .then((result) => {
            this.loginSuccess(result);
          })
          .catch(() => {
            this.setWechatUnionId(res.data.union_id);
            history.push(`/bind?unionId=${res.data.union_id}`);
          });
      });
    },
    initWeixinQrCode() {
      const container = document.getElementById("weixin_qr_code_container");
      const iframe = container.children[0];
      const onloadHandler = () => {
        if (iframe.contentDocument) {
          const code = iframe.contentDocument.URL.split("code=")[1];
          if (!code) {
            return;
          }
          const weixinCode = code.split("&")[0];
          if (!weixinCode) {
            return;
          }
          this.fetchUnionId(weixinCode);
        }
      };
      iframe.addEventListener("load", onloadHandler);
      return () => {
        iframe.removeEventListener("load", onloadHandler);
      };
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.isSubmitting = true;
          /** 判断输入项是手机号还是邮箱 */
          const newValues = pickPhoneNumberOrEmail(values);
          /** 判断登录的方式（密码或验证码） */
          const loginFunction = this.loginWithPassword
            ? "login"
            : "dynamicCodeLogin";

          UserApi[loginFunction](newValues)
            .then((res) => {
              this.loginSuccess(res);
            })
            .catch((e) => {
              this.$message.error(e.message);
            })
            .finally(() => {
              this.isSubmitting = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../common.less";

.submitBtn {
  margin-top: 12px;
}
</style>
